<template src="./template.html"></template>
<style lang="scss" src="./styles.scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  name: 'ShoppingCart',
  components: {
    SingleSelectInput,
  },
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      isDeliveryAddressDifferent: false,
      selected_deliveryAddress_country: null,
      disableButton: false,
    }
  },
  computed: {
    ...mapState('carts', [
      'cart',
      'deliveryAddress',
      'deliveryAddressCountryOptions',
    ]),
    ...mapState('auth', ['settings']),
    ...mapFields('carts', {
      deliveryAddress_firstname: 'deliveryAddress.firstname',
      deliveryAddress_lastname: 'deliveryAddress.lastname',
      deliveryAddress_address: 'deliveryAddress.address',
      deliveryAddress_house_number: 'deliveryAddress.house_number',
      deliveryAddress_zip: 'deliveryAddress.zip',
      deliveryAddress_city: 'deliveryAddress.city',
      deliveryAddress_country: 'deliveryAddress.country',
    }),
    amounts() {
      return [...Array(100).keys()].map(number => ({
        key: number,
        label: (number).toString(),
      }))
    },
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
  },
  created() {
    this.getShoppingCart()
    this.initUpdateSelectValue()
  },
  methods: {
    ...mapActions('carts', [
      'purchase',
      'removeProduct',
      'getShoppingCart',
      'saveDeliveryAddress',
      'updateCartItemOption',
    ]),
    onUpdateResults(type, args) {
      this[`selected_${type}`] = args || null
      this[`${type}`] = args || null
    },
    async onUpdateAmount(id, quantity, type, args) {
      this[`${type}_${id}`] = args

      if (quantity !== args.key) {
        await this.updateCartItemOption({ id: id, option: { quantity: args.key } })
      }
    },
    async onSubmit() {
      this.disableButton = true
      this.errors = []
      // agb will be always true in this case. Clarification came through Johannes
      const agbs = true

      if (this.isDeliveryAddressDifferent) {
        await this.saveDeliveryAddress({ address: this.deliveryAddress }).then(_ => {
          this.$emit('onCloseOverlay')
        }).catch(errors => {
          if (errors) {
            this.errors = errors.response.data
          }
        })
      }

      await this.purchase({ agb: agbs }).then(_ => {
        // after submit you will automaticly redirect to the next page
      }).catch(errors => {
        if (errors) {
          if (errors.emptyRedirect) {
            this.errors.push(this.$t('registration_slider.order_overview.error'))
          } else {
            this.errors = errors
          }
        }
      })
      this.disableButton = false
    },
    initUpdateSelectValue() {
      const index = this.deliveryAddressCountryOptions.findIndex(option => option.title === this.deliveryAddress.country)
      this.selected_deliveryAddress_country = this.deliveryAddressCountryOptions[index]
    },
    coinsRequired(price, quantity) {
      return (price * quantity)
    },
    isDisabled(valid, invalid) {
      return this.disableButton ||
             !valid ||
             invalid ||
             Boolean(this.cart.summary.props && this.cart.summary.props.error_message)
    },
  },
}
</script>
